import '../src/components/style.css';
import AddTodo from './components/AddTodo';


function App() {
  return (
    <div>
     <AddTodo/>
    </div>
  );
}

export default App;
